<template>
  <Verbrauch type="warmwasser"/>
</template>

<script>
import Verbrauch from '@/components/Verbrauch';

export default {
  components: {
    Verbrauch,
  },
};
</script>
